import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ActivatedRoute, Router, RouterStateSnapshot } from '@angular/router';
import { CommonService } from 'src/app/services/common-services/common.service';
import { environment } from 'src/environments/environment';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent {
  page: number = 3;
  public passwordResetForm!: FormGroup;
  formSubmitted = false;
  passwordResetDone: Object = {}
  sharedData: String = ''
  userEmail: string = '';
  baseUrl = environment.BASE_URL;
  token: string = '';
  decodeUrl: String = '';
  hide = true;
  cHide = true;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder,
    private commonServies: CommonService, private toastr: ToastrService
  ) { }

  ngOnInit() {
    this.route.queryParams.subscribe({
      next: (data: any) => {
        this.decodeUrl = data?.email;
      }
    })
    this.passwordResetForm = this.formBuilder.group({
      password: ['', [
        Validators.required,
        Validators.minLength(8),
        this.patternValidator(/\d/, { hasNumber: true }),
        this.patternValidator(/[A-Z]/, { hasUppercase: true }),
        this.patternValidator(/[a-z]/, { hasLowercase: true }),
        this.patternValidator(/[!@#$%^&*(),.?":{}|<>]/, { hasSpecialCharacter: true })
      ]],
      confirmPassword: ['', Validators.required],
    });

    this.commonServies.sharedData$
      .subscribe((sharedData: any) => this.sharedData = sharedData);
  }

  submit() {
    let email = this.decodeUrl.split('&token=');
    this.userEmail = email[0];
    this.token = email[1];
    let body = {
      "userName": this.userEmail,
      "email": this.userEmail,
      "passWord": this.commonServies.encryptData(this.passwordResetForm.value.confirmPassword)
    }

    let verifyUrlBody = {
      "email": this.userEmail,
      "uuidToken": this.token
    }
    let verifyUrl = `${this.baseUrl}auth-service/verifyuuid`;
    this.commonServies.postDatawithoutHeaders(verifyUrl, verifyUrlBody).subscribe({
      next: (data: any) => {
        if (data.response !== "invalid User") {
          let apiUrl = `${this.baseUrl}auth-service/resetPassword`;

          this.commonServies.postDatawithoutHeaders(apiUrl, body).subscribe((data: any) => {
            this.passwordResetDone = data;
            this.router.navigateByUrl('/login/password-changed-successfully')
          })
        }
      },
      error: (error: HttpErrorResponse) => {
        this.toastr.error(error.error.status.error.message);
      }
    })
  }


  hasError(errorName: string) {
    const control: any = this.passwordResetForm.controls['password'];
    if (control?.touched && control?.errors && errorName != 'minlength') {
      return control?.errors[errorName];
    } else if (control?.touched && control?.errors && errorName == 'minlength') {
      return control?.errors['minlength']?.actualLength < control?.errors['minlength']?.requiredLength;
    }
  }

  patternValidator(regexp: RegExp, validationOptions: any) {
    return (control: FormControl) => {
      if (!control.value) {
        // if control is empty return no error
        return null;
      }

      const valid = regexp.test(control.value);

      // if the control doesn't match the pattern
      return valid ? null : validationOptions;
    };
  }

  togglePasswordVisibility() {
    this.hide = !this.hide;
}

toggleConfirmPasswordVisibility() {
  this.cHide = !this.cHide;
}
}
